const pageNameKey = "iconButtonWithText";

export const iconButtonWithTextEn = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Icon button",
  },
};

export const iconButtonWithTextPtBr = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Botão de ícone",
  },
};

export const iconButtonWithTextDe = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Symbolbutton",
  },
};

export const iconButtonWithTextZhHans = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "图标按钮",
  },
};

export const iconButtonWithTextIt = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Pulsante icona",
  },
};

export const iconButtonWithTextEs = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Botón de icono",
  },
};

export const iconButtonWithTextNl = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Pictogramknop",
  },
};

export const iconButtonWithTextTr = {
  [pageNameKey]: {
    iconButtonWithTextAltText: "Simge düğmesi",
  },
};
